<template>
  <form class="sm-form sm-form__notification" @submit.prevent="handleSubmit">
    <h4>Email customers...</h4>
    <div v-show="step === 1">
      <div class="sm-form__notification-switch emails">
        <div
          v-for="groupType in groupTypes"
          :key="groupType.value"
          :style="{
            height: '100%',
            width: '100%',
            cursor: 'pointer',
            background:
              groupType.value === formData.group_type ? '#AAAAAA' : '',
            color: groupType.value === formData.group_type ? '#FFFFFF' : '',
          }"
          @click.prevent="selectGroupType(groupType.value)"
        >
          <span>{{ groupType.name }}</span>
        </div>
      </div>

      <input-text
        v-model="formData.subject"
        :label="'Subject'"
        :name="'subject'"
        v-validate="'required'"
        data-vv-as="Subject"
        :error="errors.first('subject')"
      />

      <div
        class="sm-form__notification-textarea"
        :class="{
          error: errors.first('body'),
        }"
      >
        <label class="sm-small">Body</label>
        <textarea
          v-model="formData.body"
          class="sm-textarea"
          style="resize: vertical; height: 200px"
          :name="'body'"
          v-validate="'required'"
          :data-vv-as="'Body'"
          :error="errors.first('body')"
        ></textarea>
        <span v-if="errors.first('body')" class="sm-tiny"
          >Body field is required</span
        >
      </div>
      <div class="btns-sec">
        <btn-block
          :class="'sm-btn--small'"
          :text="'Next'"
          :icon="''"
          @click="handleNext"
        />
      </div>
    </div>
    <div v-show="step === 2">
      <div style="margin-top: 20px">
        You are about to send this email to
        <span style="padding: 0 4px; background-color: var(--sys-bg)">{{
          formData.group_type.replace("_", " ")
        }}</span>
      </div>
      <div
        style="
          padding: 20px;
          margin: 21px 0 32px 0;
          background-color: var(--grey-4);
          border-radius: 12px;
        "
      >
        <div style="font-weight: 600">{{ formData.subject }}</div>
        <hr />
        <pre style="font-family: 'Source Sans Pro'; margin-top: 20px">{{
          formData.body
        }}</pre>
      </div>
      <div class="btns-sec">
        <btn-block
          :class="'sm-btn--small sm-btn--grey-cut'"
          :text="'Edit email'"
          :icon="''"
          @click="step = 1"
        ></btn-block>

        <btn-block
          :type="'submit'"
          :class="'sm-btn--small'"
          :text="'Send email'"
        />
      </div>
    </div>
  </form>
</template>

<script>
import InputText from "@/components/InputText";

export default {
  name: "form-mass-emails",
  components: {
    "input-text": InputText,
  },
  data() {
    return {
      step: 1,
      formData: {
        subject: "",
        body: "",
        group_type: "all_customers",
      },
    };
  },
  props: {
    groupTypes: {
      type: Array,
      requried: true,
    }
  },
  created() {},
  methods: {
    selectGroupType(groupType) {
      this.formData.group_type = groupType;
    },
    handleNext() {
      this.$validator.validate().then((valid) => {
        if (!valid) return;
        this.step = 2;
      });
    },
    handleSubmit() {
      this.$validator.validate().then((valid) => {
        if (!valid) {
          this.step = 1;
          return;
        }
        this.$emit("submit", this.formData);
      });
    },
    cehckVisibility(val) {
      return this.$emit("checkVisibility", val);
    },
  },
};
</script>